/*ěščřžýáíéúů*/
(function ($) {
	const $filters    = $('.ref-filters');
	const $grid       = $('.ref-grid');
	const $resetBtn   = $('.ref-filters__reset');
	const loadUrl     = $filters.data('load-url');

	// ── Logo slider ────────────────────────────────────────────────────────────

	$('.ref-logos__slider').slick({
		slidesToScroll: 1,
		slidesToShow: 8,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
		speed: 4000,
		arrows: false,
		draggable: false,
		pauseOnHover: false,
		pauseOnFocus: false,
		responsive: [
			{ breakpoint: 1024, settings: { slidesToShow: 5 } },
			{ breakpoint: 600,  settings: { slidesToShow: 3 } },
			{ breakpoint: 500,  settings: { slidesToShow: 2 } },
		],
	});

	// ── Filter panel toggle ────────────────────────────────────────────────────

	$filters.on('click', '.ref-filter', function () {
		const $btn    = $(this);
		const target  = $btn.data('target');
		const $panel  = $('.ref-filter-panel[data-target="' + target + '"]');
		const isOpen  = $btn.hasClass('ref-filter--active');

		// close all
		$('.ref-filter').removeClass('ref-filter--active');
		$('.ref-filter-panel').slideUp(300).removeClass('ref-filter-panel--active');

		if ( ! isOpen ) {
			$btn.addClass('ref-filter--active');
			$panel.slideDown(300).addClass('ref-filter-panel--active');
		}
	});

	// ── Filter item selection & AJAX ──────────────────────────────────────────

	function getActiveTerms(listClass) {
		return $('.' + listClass + ' .ref-filter-list__item--active')
			.map(function () { return $(this).data('term'); })
			.get();
	}

	function updateResetVisibility() {
		const hasActive = $('.ref-filter-list__item--active').length > 0;
		$resetBtn.toggle(hasActive);
	}

	function updateFilterCounts() {
		$('.ref-filter').each(function () {
			const target = $(this).data('target');
			const count  = $('.ref-filter-panel[data-target="' + target + '"] .ref-filter-list__item--active').length;
			const $count = $(this).find('.ref-filter__count');
			$count.text( count > 0 ? ' (' + count + ')' : '' );
		});
	}

	function loadFiltered() {
		const main  = getActiveTerms('ref-filter-list--functions');
		const types = getActiveTerms('ref-filter-list--product');
		const sec   = getActiveTerms('ref-filter-list--usage');

		$grid.html('<div class="loader" id="loader-1"></div>');
		$('.ref-pagination').hide();

		$.ajax({
			url: loadUrl,
			type: 'GET',
			dataType: 'html',
			data: { main: main, types: types, sec: sec },
			error: function (xhr, status, err) {
				console.error('Reference filter error:', status, err);
			},
		}).done(function (html) {
			$grid.html(html);
		});
	}

	$filters.on('click', '.ref-filter-list__item', function () {
		const $item = $(this);
		$item.toggleClass('ref-filter-list__item--active');
		updateResetVisibility();
		updateFilterCounts();
		loadFiltered();

		// GA4/GTM: jen zapnutí filtru (ne odškrtnutí), ať se nezdvojuje signál.
		if ( $item.hasClass('ref-filter-list__item--active') ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'reference_interaction',
				type: 'filter_use',
				filter_group: $item.closest('.ref-filter-panel').data('target') || '',
				filter_value: $item.data('term') || ''
			});
		}
	});

	// ── Init ──────────────────────────────────────────────────────────────────

	updateResetVisibility();
	updateFilterCounts();

})(jQuery);
